import { useStore } from 'hooks/useStore';
import { observer } from 'mobx-react';
import { useEffect } from 'react';

const PublicFeatureFlagInitializer = observer(() => {
  const { FeatureFlagStore } = useStore();

  useEffect(() => {
    FeatureFlagStore.loadPublicFlags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
});

export default PublicFeatureFlagInitializer;
